import React from 'react';

export const DecalVariantSpecific = ({variant, onChange}) => (
    <div className="colspan type-specific">
        <label htmlFor={`specularColor-${variant.id}`}>Specular RGB (shine)</label>
        <input type="text" id={`specularColor-${variant.id}`} value={variant.typeSpecific.specularColor}
               onChange={({target}) => onChange('specularColor', target.value)}/>

        <label htmlFor={`uSize-${variant.id}`}>U size:</label>
        <input type="number" step="0.1" onChange={({target}) => onChange('uSize', target.value)}
               id={`uSize-${variant.id}`}
               value={variant.typeSpecific.uSize} placeholder='decal u length'/>

        <label htmlFor={`vSize-${variant.id}`}>V size:</label>
        <input type="number" step="0.1" onChange={({target}) => onChange('vSize', target.value)}
               id={`vSize-${variant.id}`}
               value={variant.typeSpecific.vSize} placeholder='decal v length'/>
    </div>);
